// Utils
import makeCanDropFn from '../element/dnd/canDrop/makeCanDropFn';
import preventAllElementPredicate from '../element/dnd/canDrop/preventAllElementPredicate';
import { isAnnotation, isCommentThread, isLine } from '../../common/elements/utils/elementTypeUtils';
import { getIsCollapsed } from '../../common/elements/utils/elementPropertyUtils';
import preventSnappedDragDrop from '../element/dnd/canDrop/preventSnappedDragDrop';

const isCollapsedCommentThread = (el) => isCommentThread(el) && getIsCollapsed(el);

export default makeCanDropFn([
    ({ props }) => props.isEditable,
    preventSnappedDragDrop,
    preventAllElementPredicate([isLine, isCollapsedCommentThread, isAnnotation]),
]);
